import React from 'react';
import styles from '../../styles/Pagination.module.css'; // Add your styles

const Pagination = ({ totalGames, gamesPerPage, currentPage, onPageChange }) => {
  const totalPages = Math.ceil(totalGames / gamesPerPage);
  
  const handlePageChange = (page) => {
    onPageChange(page);
    window.scrollTo({
      top: 0,
      behavior: 'smooth', // Smooth scrolling to the top
    });
  };

  return (
    <>


    <div className={styles.pagination}>
    <div className={styles.pagination_text} >Pages:</div>
      {[...Array(totalPages)].map((_, index) => (
        <button
          key={index}
          onClick={() => handlePageChange(index + 1)}
          className={currentPage === index + 1 ? styles.active : ''}
        >
          {index + 1}
        </button>
      ))}
    </div>
    </>
  );
};

export default Pagination;
